module.exports = __webpack_public_path__ + "cha.png?bc1170b6472152fc4aee562dbcd1d82e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/cha.png
// module id = 527
// module chunks = 0